// features/map/ui/DangerTitleAlert.tsx
import { useEffect } from 'react';
import { useAppSelector } from '../../../hooks/redux';
import { selectFilteredMachineryWithLocation } from '../model/selectors';
import { getMarkerState } from '../utils/machineryMarkerState';

/**
 * Тревога в заголовке вкладки: пока хотя бы у одной машины активна
 * danger-тревога (обрыв питания / перегрев / check-engine — та же логика,
 * что красит маркер, getMarkerState), title получает префикс «⛔ (n) ».
 * Диспетчер с десятком фоновых вкладок видит проблему, не открывая приложение.
 *
 * Ничего не рендерит. Данные — тот же селектор, что у онлайн-карты; вне
 * страницы карты работает по последнему снимку стора (телеметрию наполняет
 * WS карты) — тревога, замеченная на карте, продолжает висеть на вкладке
 * с любой страницы, пока не разрешится или сессия не перезагрузится.
 *
 * Восстановление title — снятием префикса, а не запомненной строкой: если
 * что-то ещё поменяет title, мы не перетрём чужое значение старым снимком.
 */
const TITLE_PREFIX_RE = /^⛔ \(\d+\) /;

const DangerTitleAlert = () => {
    const machinery = useAppSelector(selectFilteredMachineryWithLocation);
    const dangerCount = machinery.reduce(
        (n, m) => n + (getMarkerState(m).dangerAlert ? 1 : 0),
        0,
    );

    useEffect(() => {
        if (dangerCount === 0) return;
        document.title = `⛔ (${dangerCount}) ${document.title.replace(TITLE_PREFIX_RE, '')}`;
        return () => {
            document.title = document.title.replace(TITLE_PREFIX_RE, '');
        };
    }, [dangerCount]);

    return null;
};

export default DangerTitleAlert;